import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = "查看全部" }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2.5 text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-6 w-1.5 rounded-full bg-accent-500" aria-hidden="true" />
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}